import { Tag } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledTag = styled(Tag)<{ $hide: boolean }>`
  background: rgba(45, 61, 95, 1);
  border: none;
  ${({ $hide }) => $hide && 'display: none'};
`;

export const StyledTagContent = styled.span`
  display: flex;
  gap: 0.6rem;
`;

export const StyledTagText = styled.span`
  color: ${({ theme }) => theme.colors.primary.main};
`;
